import {Paper} from "@mui/material";
import React from "react";

export default function PlainPaper(props: {children?: React.ReactNode}){
    return (
        <Paper sx={{mx: 0, px: 0, borderRadius: 0, boxShadow: 'none'}}>
            { props.children }
        </Paper>
    );
}